import { Context } from "csi/def/Context";
import Heading from "csi/def/Heading";
import Spec from "csi/core/Spec";
import html from "csi/html";
import Path from "csi/table/matrix/Path";
import { C8Node } from "csi/typings";
import declare from "dojo/_base/declare";
import _ from "lodash";
import { specValueIdMap } from "src/SpecificationDataSheet/sharedSectionMatrixService";
import { default as SharedSectionMatrixMixin } from "src/SpecificationDataSheet/_SharedSectionMatrixMixin";
import VariantsTable from "./VariantsTable";

export = declare([Path, SharedSectionMatrixMixin], {
	/**
	 * @override
	 * Add any dependency paths necessary to process matrix
	 */
	addDependencyPaths(h: Heading, paths: string[]): void {
		paths.push("Child:RetailVariants/Child:VariantComponents/Child:Component/Child:SharedSpecItemDefinitionMap");
		this.inherited(arguments);
	},

	/**
	 * @override
	 * generate the sub headings to merge them into the existing matrix container
	 */
	onPathSubSpecParams(ctx: Context, params: Partial<Spec>, columnIndex: number): void {
		if (params.heading.m_name === "SpecMatrix") {
			const { cache, view } = ctx;
			const variantTable = view as unknown as typeof VariantsTable.prototype;
			let specItems = variantTable.specItems;

			// remove the duplicated items
			const specDictionary = _.keyBy<C8Node>(specItems, (item) => item.$URL);
			specItems = Object.values(specDictionary);

			const { relRoot } = view;
			const targetType = relRoot.getTargetType();
			const specs = [];

			// create specs for each column node
			ctx.forEach(specItems, (ctx) => {
				const defn = ctx.getNode();
				const columnUrl = defn.$URL;
				const vad = cache.get(defn.ValueAttributeDefinition);
				const format = vad.Format;
				const type = vad.ValueType;
				const id = specValueIdMap[type];

				// Create Spec
				const mixin = this as unknown as typeof SharedSectionMatrixMixin.prototype;
				const spec = mixin.createSpec(ctx, targetType, "Child:VariantComponents/Child:Component", "SharedSpecItemDefinitionMap", defn.SysID, id, format, columnUrl, defn.$Name, html.CSS_NOT_APPLICABLE);

				specs.push(spec);
			});

			params.subs = specs;
		}
	},

	/**
	 * @override
	 * Merge the sub heading to the existing matrix
	 */
	_onColumnSpecAddSub(h: Heading, sc: Spec, subs: object[], params: Partial<Spec>): void {
		if (h.m_name === "SpecMatrix") {
			params.subs?.forEach((entry) => subs.push(entry));
		} else {
			this.inherited(arguments);
		}
	},
});